export enum ContentViewType {
  Grid = "grid",
  List = "list",
  Calendar = "calendar",
}
